import { z } from "zod";

const emptyToUndefined = (value) => {
  if (value === undefined || value === null) return undefined;
  const str = String(value).trim();
  return str.length ? str : undefined;
};

export const parkingSlotCreateSchema = z.object({
  society_id: z
    .preprocess((v) => Number(v), z.number().int().positive("Society is required")),
  slot_code: z
    .string()
    .trim()
    .min(1, "Slot code is required")
    .max(40, "Slot code is too long")
    .transform((v) => v.toUpperCase()),
  slot_type: z.preprocess(
    emptyToUndefined,
    z.string().trim().min(1, "Type is required").max(20).optional()
  ),
});

export const parkingAssignSchema = z.object({
  slot_id: z.preprocess((v) => Number(v), z.number().int().positive("Slot is required")),
  flat_id: z.preprocess((v) => Number(v), z.number().int().positive("Unit is required")),
});

export const parkingGenerateSchema = z.object({
  society_id: z.preprocess((v) => Number(v), z.number().int().positive("Society is required")),
  four_wheeler_count: z.preprocess((v) => Number(v), z.number().int().min(0).max(5000)),
  two_wheeler_count: z.preprocess((v) => Number(v), z.number().int().min(0).max(5000)),
});

export const zodErrorToFieldErrors = (zodError) => {
  const out = {};
  const flattened = zodError?.flatten?.();
  const fieldErrors = flattened?.fieldErrors || {};
  Object.keys(fieldErrors).forEach((key) => {
    const first = fieldErrors[key]?.[0];
    if (first) out[key] = first;
  });
  return out;
};
